import React from 'react';
import { ConfirmDialog } from '../../common/ConfirmDialog';

interface GridPagerSkipLimitDialogProps {
  translate: (key: string) => string;
  onConfirm: () => void;
}

export const GridPagerSkipLimitDialog: React.FC<GridPagerSkipLimitDialogProps> = ({ translate, onConfirm }) => {
  return (
    <ConfirmDialog
      className="filterActionsDialog"
      title={translate('custom.grid.maxSkipItems.dialogHeader')}
      message={translate('custom.grid.maxSkipItems.dialogBody')}
      confirmButtonOnly={true}
      onConfirm={onConfirm}
    />
  );
};
